import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');

        const slidesCount = this.element.querySelectorAll('.swiper .swiper-slide').length;
        const middleIndex = Math.floor(slidesCount / 2);

        let config = {
            effect: 'cards',
            grabCursor: true,
            loop: false,
            initialSlide: middleIndex,
            cardsEffect: {
                slideShadows: false,
                perSlideOffset: 11,
                perSlideRotate: 5,
                rotate: true,
            },
            observer: true,
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({EffectCards}) => {
                Swiper.use([EffectCards]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}